




















































































































import { Component, Watch } from 'vue-property-decorator';
import PickerBase from './base';
import TagSearchAppend from '@/views/reports/pickers/tag-search-append.vue';
import { TagsLogicalRelationEnum,TextLogicalRelationEnum, MarksFilterModeEnum } from '@/services/models/Enums';
import TagSearchSelect from '@/views/reports/pickers/tag-search-select.vue';
import TextOrSearchSelect from '@/views/reports/pickers/text-or-search-select.vue';
import query from '@/components/query/query-constructor';

@Component({
  components: {
    TagSearchSelect,
    TextOrSearchSelect,
    TagSearchAppend
  }
})
export default class TagSearch extends PickerBase {
  iconList: any[] = [
    {
      label: this.t('No mark'),
      text: 'no-mark',
      color: this.$colors.black,
      value: -1,
    },
    {
      icon: 'fas fa-ban',
      text: 'ban',
      color: this.$colors.red,
      value: 0,
    },
    {
      icon: 'fas fa-minus',
      text: 'minus',
      color: this.$colors.red,
      value: 1,
    },
    {
      icon: 'fas fa-plus',
      text: 'plas',
      color: this.$colors.green,
      value: 2,
    },
    {
      icon: 'fas fa-check',
      text: 'check',
      color: this.$colors.green,
      value: 3,
    },
    {
      icon: 'fas fa-pause',
      text: 'pause',
      color: this.$colors.graphite,
      value: 4,
    },
    {
      icon: 'fas fa-heart',
      text: 'heart',
      color: this.$colors.red,
      value: 5,
    },
    {
      icon: 'fas fa-star',
      text: 'star',
      color: this.$colors.tangerine,
      value: 6,
    },
    {
      icon: 'fas fa-trash',
      text: 'heart',
      color: this.$colors.graphite,
      value: 7,
    },
  ];

  focused: boolean = false;
  searchTags: string = '';

  get hasMarks() {
    return !!this.computedType.includes('custom') || this.isMainTab
  }

  get isTags() {
    return this.searchBy?.startsWith('tags')
  }

  get isMarks() {
    return this.searchBy === 'marks' || this.searchBy?.startsWith('marks-')
  }

  get searchBy() {
    return this.$store.getters.tableQueryTemporarySearch.searchBy
  }

  get hideTags() {
    const {name} = this.$route;
    const {type} = this.$route.params;

    if(['app.postbacks', 'app.conversions', 'app.errors'].includes(name)) return true;
    return name === 'app.report'
      &&
      ['countries', 'languages', 'cities', 'states', 'isps', 'mobile-carriers', 'connection-types', 'screen-resolutions', 'device-models', 'device-types', 'device-vendors', 'os-versions', 'browsers', 'browser-versions', 'useragents', 'oses'].includes(type);

  }

  get switchSearchMode() {
    const search = this.$store.getters.tableQueryTemporarySearch || {}
    const searchBy = search.searchBy || 'text-and'
    // Legacy bookmarks/URLs used searchBy=marks without include/exclude mode
    if (searchBy === 'marks') {
      return search.marksFilterMode === MarksFilterModeEnum.exclude
        ? 'marks-exclude'
        : 'marks-include'
    }
    return searchBy
  }

  set switchSearchMode(value: string) {
    const current = this.$store.getters.tableQueryTemporarySearch || {};
    this.$store.commit('tableQuerySearchTemporary',{
      searchBy:value,
      ...(value.startsWith('text') ? {
        textValue: value === current.searchBy
          ? (current.textValue || '')
          : (value.includes('and') ? '' : []),
        textLogicalRelation:value.includes('and')
          ? TextLogicalRelationEnum.and
          : TextLogicalRelationEnum.or }:{}),
      ...(value.startsWith('tags') ? {
        tagsValue: current.tagsValue || [],
        tagsLogicalRelation:value.includes('and')
          ? TagsLogicalRelationEnum.and
          : TagsLogicalRelationEnum.or }:{}
      ),
      ...(value === 'marks' || value.startsWith('marks-') ? {
        marksValue: current.marksValue || [],
        marksFilterMode: value.includes('exclude')
          ? MarksFilterModeEnum.exclude
          : MarksFilterModeEnum.include
      }:{})
    })
  }

  get modelText(){
    return this.$store.getters.tableQueryTemporarySearch.textValue
  }

  set modelText(value){
    const {searchBy} = this.$store.getters.tableQueryTemporarySearch;
    this.$store.commit('tableQuerySearchTemporary', {
      searchBy,
      textValue: this.searchBy.includes('and')
          ? (value || '').trim()
          : value.map(item=> item.trim()).filter(item=>!!item),
      textLogicalRelation: this.searchBy.includes('and')
        ? TagsLogicalRelationEnum.and
        : TagsLogicalRelationEnum.or
    })
  }

  get modelMarks(){
    const iconListObject = Object.values(this.iconList);
    return  this.$store.getters.tableQueryTemporarySearch.marksValue?.map(item=> iconListObject[item+1]);
  }

  set modelMarks(value){
    const current = this.$store.getters.tableQueryTemporarySearch || {};
    const marksFilterMode = current.searchBy?.includes('exclude')
      || current.marksFilterMode === MarksFilterModeEnum.exclude
      ? MarksFilterModeEnum.exclude
      : MarksFilterModeEnum.include;
    const marksValue = Array.isArray(value)
      ? value.map(item => item?.value ?? item).filter(item => item !== undefined && item !== null)
      : (current.marksValue || []);
    this.$store.commit('tableQuerySearchTemporary', {
      searchBy: `marks-${marksFilterMode}`,
      marksFilterMode,
      marksValue,
    });
  }

  get modelTags(){
    return this.$store.getters.tableQueryTemporarySearch.tagsValue
  }

  set modelTags(value){
    const {searchBy} = this.$store.getters.tableQueryTemporarySearch;
    const trimValues = value.map(item=> item.trim()).filter(item=>!!item);
    this.$store.commit('tableQuerySearchTemporary', {
      searchBy,
      tagsValue: trimValues,
      ...(searchBy.startsWith('tags') ? { tagsLogicalRelation:(this.searchBy.includes('and') ? TagsLogicalRelationEnum.and : TagsLogicalRelationEnum.or) }:{})
    });
  }

  get isShowClear() {
    const {searchBy} = this.$store.getters.tableQueryTemporarySearch;
    if(searchBy?.startsWith('tags')){
      return !!this.$store.getters.tableQueryTemporarySearch.tagsValue?.length
    }
    if(this.isMarks){
      return !!this.$store.getters.tableQueryTemporarySearch.marksValue?.length
    }
    if(searchBy === 'text-and' || searchBy === 'text-or'){
      return !!this.$store.getters.tableQueryTemporarySearch.textValue?.length
    }
  }

  handleInputFocus() {
    this.focused = true;
  }

  handleInputBlur() {
    this.focused = false;
  }

  handleClear() {
    const getPayload = ()=>{
      if(this.searchBy?.startsWith('text')){
        return{
          name: 'textValue',
          value: ''
        }
      }
      if(this.isMarks){
        const current = this.$store.getters.tableQueryTemporarySearch || {};
        const marksFilterMode = this.searchBy?.includes('exclude')
          || current.marksFilterMode === MarksFilterModeEnum.exclude
          ? MarksFilterModeEnum.exclude
          : MarksFilterModeEnum.include;
        return{
          name: 'marksValue',
          value: [],
          searchBy: `marks-${marksFilterMode}`,
          marksFilterMode,
        }
      }
      if(this.searchBy?.startsWith('tags')){
        return{
          name: 'tagsValue',
          value: []
        }
      }
    }
    const payload = getPayload();
    const { name, value, searchBy = this.searchBy, marksFilterMode } = payload;
    this.$store.commit('tableQuerySearchTemporary', {
      searchBy,
      [name]:value,
      ...(marksFilterMode ? { marksFilterMode } : {})
    });
  }

  handleTagsChange() {
    this.searchTags = '';
  }

  mounted() {
    this.bus.on('apply-filters', this.onBusApplyFilters);
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);
    if(!this.isReport()){
      this.applyDataFromUrl()
      this.$store.commit('tableQuerySearch');
    }
  }

  beforeDestroy() {
    this.bus.off('apply-filters', this.onBusApplyFilters);
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
  }

  onBusReportTabAdded() {
    // take data from url on active report page
    this.applyDataFromUrl()
    this.$store.commit('tableQuerySearch');
  }

  onBusReportTabUpdated() {
    if(!this.searchBy){
      this.$store.commit('tableQuerySearchTemporary', {
        searchBy:'text-and',
        textLogicalRelation: 'and',
        textValue: ''
      })
      this.applyDataFromUrl()
      this.$store.commit('tableQuerySearch');
    }
  }

  onBusApplyFilters() {
    this.$store.commit('tableQuerySearch');
    this.pushURL()
  }

  applyDataFromUrl() {
    const {search, marks, tags, tagsLogicalRelation, textLogicalRelation='and', searchBy='text', marksFilterMode} = query.decode(this.$route.params.data);
    switch (searchBy) {
      case 'text': {
        const relation = textLogicalRelation === TextLogicalRelationEnum.or
          ? TextLogicalRelationEnum.or
          : TextLogicalRelationEnum.and
        const terms = Array.isArray(search) ? search : (search ? [search] : [])
        return this.$store.commit('tableQuerySearchTemporary', {
          searchBy:`text-${relation}`,
          textLogicalRelation: relation,
          textValue: relation === TextLogicalRelationEnum.or
            ? terms.map((item: unknown) => String(item).trim()).filter((item: string) => !!item)
            : (search || '')
        });
      }
      case 'marks': {
        const mode = marksFilterMode === MarksFilterModeEnum.exclude
          ? MarksFilterModeEnum.exclude
          : MarksFilterModeEnum.include;
        return this.$store.commit('tableQuerySearchTemporary', {
          searchBy: `marks-${mode}`,
          marksFilterMode: mode,
          marksValue: marks || []
        });
      }
      case 'tags':
        return this.$store.commit('tableQuerySearchTemporary', {
          searchBy:`tags-${tagsLogicalRelation}`,
          tagsLogicalRelation,
          tagsValue: tags || [],
        });
    }
  }
  searchByText(ev: KeyboardEvent) {
    if (ev.key === 'Enter') {
      this.bus.emit('click-apply-filters');
    }
  }


  @Watch('$store.getters.tableQueryForCurrentTab.groupBy', { immediate: true })
  onRouteChange() {
    if(this.isMarks && !this.hasMarks || this.searchBy?.startsWith('tags') && this.hideTags || this.searchBy==='text-or' && this.hideTags){
      this.switchSearchMode = 'text-and';
      this.bus.emit('click-apply-filters');
    }

  }

  @Watch('$store.getters.tableQueryForCurrentTab.groupBy')
  onGroupByChange() {
    // especially per tab case
    if(!this.searchBy){
      this.$store.commit('tableQuerySearchTemporary', {
        searchBy:'text-and',
        textLogicalRelation: 'and',
        textValue: ''
      })
      this.$store.commit('tableQuerySearch');
      this.pushURL()
    }
  }
}
